import styled from 'styled-components';

// Components
import { Typography } from '../Typography';
import { SpecialTag } from '../SpecialTag';
import { InputTextArea } from '../../inputs/InputTextArea';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${({ theme }) => theme.spacing.xl};
  padding: ${({ theme }) => theme.spacing.xxl};
  background-color: ${({ theme }) =>
    theme.colors.backgroundLila}; /* CAMBIO: Color lila según Figma */
  border-radius: ${({ theme }) => theme.borderRadius.md};
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    padding: ${({ theme }) => theme.spacing.xl};
  }
`;

export const TitleTagContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.xl};
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column-reverse;
    gap: ${({ theme }) => theme.spacing.m};
  }
`;

export const Title = styled(Typography)`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    font-size: ${({ theme }) => theme.fontSize.M};
  }
`;

export const RowContainer = styled.div`
  display: flex;
  padding-bottom: ${({ theme }) => theme.spacing.xl};
  border-bottom: 0.1rem solid ${({ theme }) => theme.colors.greyLight};
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
  }
`;

export const RowContainerLast = styled(RowContainer)`
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing.xl};
  padding: 0;
  border: none;
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
  }
`;

export const RowSubContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xl};
  overflow: hidden;
`;

export const RowSubContainerBottom = styled(RowSubContainer)`
  width: 100%;
  max-width: 63rem;
`;

export const RowSubContainerLeft = styled(RowSubContainer)`
  padding: 0 14rem 0 0;
  border-right: 0.1rem solid ${({ theme }) => theme.colors.greyLight};
  flex-shrink: 0;
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    padding: 0 ${({ theme }) => theme.spacing.xxxl} 0 0;
  }
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    padding: 0 0 ${({ theme }) => theme.spacing.xl} 0;
    border-right: none;
    border-bottom: 0.1rem solid ${({ theme }) => theme.colors.greyLight};
  }
`;

export const RowSubContainerRight = styled(RowSubContainer)`
  padding: 0 0 0 14rem;
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    padding: 0 0 0 ${({ theme }) => theme.spacing.xxxl};
  }
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    padding: ${({ theme }) => theme.spacing.xl} 0 0 0;
  }
`;

export const ColumnTitleContainer = styled.div``;

export const SmallTitle = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.spacing.s};
`;

export const ColumnsContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xl};
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.portraitTablet * theme.percentBaseResponsive}rem) {
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.xxs};
  }
`;

export const ColumnsContainerDouble = styled(ColumnsContainer)`
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.landscapeTablet * theme.percentBaseResponsive}rem) {
    &:first-of-type {
      flex-direction: column;
      gap: ${({ theme }) => theme.spacing.xxs};
    }
  }
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.xxs};
  min-width: 0;
`;

export const ContainerButtons = styled.form`
  display: flex;
  align-self: end;
  gap: ${({ theme }) => theme.spacing.s};
`;

export const Tag = styled(SpecialTag)``;

export const ChangeStateTagContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  cursor: pointer;
`;

export const ChangeStateTag = styled(SpecialTag)`
  cursor: pointer;
  border-radius: 100rem 0 0 100rem;

  /* Texto blanco para el título "Cambiar estado" */
  span {
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const StateTag = styled(SpecialTag)`
  cursor: pointer;
  border-radius: 0 100rem 100rem 0;
`;

export const InputTextAreaStyled = styled(InputTextArea)`
  width: 100%;
  max-width: 89.2rem;
  @media (max-width: ${({ theme }) =>
    theme.breakPoints.smallDesktop * theme.percentBaseResponsive}rem) {
    max-width: 86.9rem;
  }
`;
